import { Component } from '@angular/core';
import { VideoControlsComponent } from '../video-controls/video-controls.component';

@Component({
  selector: 'studio-play-pause-button',
  templateUrl: './play-pause-button.component.html',
  styleUrls: ['./play-pause-button.component.scss'],
})
export class PlayPauseButtonComponent {
  get isPaused() {
    return this.videoControls.video.paused;
  }

  constructor(protected videoControls: VideoControlsComponent) {}

  protected clicked() {
    if (this.isPaused) {
      this.videoControls.video.play();
    } else {
      this.videoControls.video.pause();
    }
  }
}
